import PropTypes from 'prop-types';

export const PreviewPolyPartsProps = {
	// points: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
	// poly: PropTypes.string,

	// EXAMPLE USE TWO types - PropTypes.oneOfType([
	// 	PropTypes.string,
	// 	PropTypes.number
	//   ]),
}

export const PreviewPolyProps = {
	error: PropTypes.any,
	fetched: PropTypes.bool,
	fetching: PropTypes.bool,
	id: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
	// parts: PropTypes.arrayOf(PropTypes.shape(PreviewPolyPartsProps)),
	parts: PropTypes.array
}